{
  "brand": "Configurare inițială",
  "progress": {
    "account": "Cont",
    "school": "Școală",
    "email": "Email",
    "finish": "Finalizare"
  },
  "account": {
    "title": "Bun venit în Cadence",
    "subtitle": "Hai să configurăm școala. Mai întâi, dă-i un nume și creează contul de administrator.",
    "schoolName": "Numele școlii",
    "schoolNamePlaceholder": "ex. Academia de Dans Riverside",
    "firstName": "Prenume",
    "lastName": "Nume",
    "email": "Adresă de email",
    "password": "Parolă",
    "confirmPassword": "Confirmă parola",
    "weak": "Parola trebuie să aibă cel puțin 8 caractere.",
    "mismatch": "Parolele nu coincid.",
    "submit": "Creează contul și continuă"
  },
  "school": {
    "title": "Detaliile școlii",
    "subtitle": "Setează moneda, fusul orar și limba. Poți modifica toate acestea ulterior în Setări.",
    "currency": "Moneda principală",
    "currencyHint": "Moneda principală a școlii — taxele se încasează în ea și toate plățile, veniturile și rapoartele sunt totalizate în ea. Poți adăuga mai multe monede și o poți schimba mai târziu în Setări.",
    "timezone": "Fus orar",
    "language": "Limba implicită",
    "contactEmail": "Email de contact",
    "save": "Salvează și continuă"
  },
  "email": {
    "title": "Livrare email",
    "subtitle": "Configurează un furnizor de email ca să poți invita profesori și elevi și să trimiți resetări de parolă. Poți sări peste și configura mai târziu.",
    "provider": "Furnizor",
    "apiKey": "Cheie API",
    "fromAddress": "Adresă expeditor",
    "fromName": "Nume expeditor (opțional)",
    "keyPrefixHint": "Cheia ar trebui să înceapă cu „{prefix}”.",
    "noMasterKey": "Cheile de email sunt stocate criptat. Setează secretul ENCRYPTION_KEY al Worker-ului înainte de a salva o cheie — până atunci, sari peste acest pas și configurează email-ul mai târziu în Setări.",
    "save": "Salvează și continuă"
  },
  "finish": {
    "title": "Totul e gata",
    "subtitle": "Școala ta este pregătită. Iată câțiva pași opționali — toți disponibili oricând din meniu.",
    "addTeachers": "Adaugă profesori",
    "addTeachersBody": "Invită profesori și oferă-le acces de autentificare.",
    "addStudents": "Adaugă elevi",
    "addStudentsBody": "Creează elevi și trimite linkuri de înrolare.",
    "configureFees": "Configurează facturarea",
    "configureFeesBody": "Definește taxe, niveluri de preț și metode de plată.",
    "features": "Funcționalități",
    "featuresBody": "Activează sau dezactivează module opționale.",
    "go": "Finalizează și mergi la panou"
  },
  "skip": "Sari peste"
}
